import * as React from "react";
import { SVGProps } from "react";
const SvgDashboard = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.5 6a1 1 0 0 1 1 1v18h22a1 1 0 0 1 0 2h-23a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1Zm5 7a1 1 0 0 1 1 1v8a1 1 0 0 1-2 0v-8a1 1 0 0 1 1-1Zm5 4a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0v-4a1 1 0 0 1 1-1Zm5-7a1 1 0 0 1 1 1v11a1 1 0 0 1-2 0V11a1 1 0 0 1 1-1Zm5 3a1 1 0 0 1 1 1v8a1 1 0 0 1-2 0v-8a1 1 0 0 1 1-1Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDashboard;
